import { render, staticRenderFns } from "./Changepasswd.vue?vue&type=template&id=d1b9cdc4&"
import script from "./Changepasswd.vue?vue&type=script&lang=ts&"
export * from "./Changepasswd.vue?vue&type=script&lang=ts&"
import style0 from "./Changepasswd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports